export const CABIN_CLASS = {
  ECONOMY: 'ECONOMY',
  PREMIUM_ECONOMY: 'PREMIUM_ECONOMY',
  BUSINESS: 'BUSINESS',
  FIRST: 'FIRST',
} as const;

export type CabinClass = keyof typeof CABIN_CLASS;

export const CABIN_CLASS_PROTO = {
  [CABIN_CLASS.ECONOMY]: 'CABIN_CLASS_ECONOMY',
  [CABIN_CLASS.PREMIUM_ECONOMY]: 'CABIN_CLASS_PREMIUM_ECONOMY',
  [CABIN_CLASS.BUSINESS]: 'CABIN_CLASS_BUSINESS',
  [CABIN_CLASS.FIRST]: 'CABIN_CLASS_FIRST',
} as const;

export type CabinClassProto = (typeof CABIN_CLASS_PROTO)[keyof typeof CABIN_CLASS_PROTO];
